var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 14 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.2598C0.9 17.2598 0 18.1598 0 19.2598H14C14 18.1598 13.1 17.2598 12 17.2598H8V15.2598H11C12.1 15.2598 13 14.3598 13 13.2598H5C3.34 13.2598 2 11.9198 2 10.2598C2 9.16977 2.59 8.21977 3.47 7.68977C3.88 8.27977 4.53 8.68977 5.3 8.74977C6 8.80977 6.66 8.55977 7.15 8.12977L7.74 9.73977L8.68 9.39977L9.02 10.3398L10.9 9.65977L10.56 8.71977L11.5 8.37977L8.76 0.859766L7.82 1.19977L7.48 0.259766L5.6 0.939766L5.94 1.87977L5 2.22977L5.56 3.77977C4.39 3.73977 3.37 4.52977 3.08 5.63977C1.27 6.39977 0 8.17977 0 10.2598C0 13.0198 2.24 15.2598 5 15.2598V17.2598H2ZM7.86 2.77977L9.57 7.47977L8.63 7.81977L6.92 3.11977L7.86 2.77977ZM5.5 5.25977C6.05 5.25977 6.5 5.70977 6.5 6.25977C6.5 6.80977 6.05 7.25977 5.5 7.25977C4.95 7.25977 4.5 6.80977 4.5 6.25977C4.5 5.70977 4.95 5.25977 5.5 5.25977Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestResults);
export default __webpack_public_path__ + "static/media/testResults.245d22e7.svg";
export { ForwardRef as ReactComponent };